import { MusicNotesIcon as PhosphorMusicNotesIcon } from "@phosphor-icons/react/dist/ssr/MusicNotes";

import { createAppIcon } from "@/components/createAppIcon";

export const CollectionIcon = /* @__PURE__ */ createAppIcon(PhosphorMusicNotesIcon);
export const MusicNotesIcon = /* @__PURE__ */ createAppIcon(PhosphorMusicNotesIcon);
export const MusicLibraryIcon = CollectionIcon;
